const EmptyIllustration = () => (
  <svg
    width="180"
    height="160"
    viewBox="0 0 180 160"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="90" cy="148" rx="62" ry="8" fill="#0d1117" opacity="0.3" />
    <path d="M30 130 L28 72 L62 68 L66 130 Z" fill="#2a2f3a" />
    <path d="M150 130 L152 72 L118 68 L114 130 Z" fill="#2a2f3a" />
    <rect x="34" y="75" width="112" height="58" rx="4" fill="#353b47" />
    <path d="M34 75 L34 68 L60 68 L66 75 Z" fill="#3d4455" />
    <rect
      x="52"
      y="58"
      width="68"
      height="86"
      rx="3"
      fill="#d8dce5"
      transform="rotate(-4 86 101)"
    />
    <rect
      x="60"
      y="80"
      width="44"
      height="3"
      rx="1"
      fill="#bcc1cc"
      transform="rotate(-4 82 81)"
    />
    <rect
      x="60"
      y="88"
      width="38"
      height="3"
      rx="1"
      fill="#bcc1cc"
      transform="rotate(-4 79 89)"
    />
    <rect
      x="56"
      y="52"
      width="68"
      height="86"
      rx="3"
      fill="#dde0e8"
      transform="rotate(2 90 95)"
    />
    <rect
      x="64"
      y="72"
      width="44"
      height="3"
      rx="1"
      fill="#c2c7d0"
      transform="rotate(2 86 73)"
    />
    <rect
      x="64"
      y="80"
      width="36"
      height="3"
      rx="1"
      fill="#c2c7d0"
      transform="rotate(2 82 81)"
    />
    <rect
      x="64"
      y="88"
      width="40"
      height="3"
      rx="1"
      fill="#c2c7d0"
      transform="rotate(2 84 89)"
    />
    <rect x="58" y="48" width="68" height="88" rx="3" fill="#e8eaed" />
    <circle cx="72" cy="62" r="7" fill="#3dcc82" opacity="0.15" />
    <text
      x="72"
      y="67"
      textAnchor="middle"
      fontSize="10"
      fontWeight="700"
      fill="#3dcc82"
      fontFamily="inherit"
    >
      P
    </text>
    <rect x="66" y="76" width="44" height="2.5" rx="1" fill="#c8cdd6" />
    <rect x="66" y="83" width="36" height="2.5" rx="1" fill="#c8cdd6" />
    <rect x="66" y="90" width="40" height="2.5" rx="1" fill="#c8cdd6" />
    <rect x="66" y="97" width="28" height="2.5" rx="1" fill="#c8cdd6" />
    <rect x="66" y="104" width="34" height="2.5" rx="1" fill="#c8cdd6" />
    <circle
      cx="100"
      cy="58"
      r="18"
      fill="none"
      stroke="#3dcc82"
      strokeWidth="2.5"
      opacity="0.5"
    />
    <line
      x1="113"
      y1="71"
      x2="122"
      y2="80"
      stroke="#3dcc82"
      strokeWidth="2.5"
      strokeLinecap="round"
      opacity="0.5"
    />
    <line
      x1="94"
      y1="58"
      x2="106"
      y2="58"
      stroke="#3dcc82"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.6"
    />
    <rect
      x="108"
      y="38"
      width="28"
      height="26"
      rx="2"
      fill="#3dcc82"
      transform="rotate(15 122 51)"
    />
    <path
      d="M118 42 Q121 38 124 42 Q127 46 124 49 Q121 52 118 49"
      stroke="#1a1e1c"
      strokeWidth="1.5"
      fill="none"
      transform="rotate(15 122 46)"
      strokeLinecap="round"
    />
    <g transform="rotate(-30 48 88)">
      <rect x="34" y="82" width="8" height="34" rx="1" fill="#d4a44c" />
      <polygon points="34,116 42,116 38,126" fill="#e8cfa0" />
      <polygon points="36,122 40,122 38,126" fill="#2a2a2a" />
      <rect x="34" y="80" width="8" height="4" fill="#888" />
      <rect x="34" y="76" width="8" height="5" rx="1" fill="#c9756a" />
    </g>
  </svg>
);

export default function EmptyState({ title, subtitle, ctaLabel, onCta }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "320px",
        padding: "48px 24px",
        textAlign: "center",
      }}
    >
      <EmptyIllustration />
      <div
        style={{
          marginTop: "20px",
          fontSize: "18px",
          fontWeight: "600",
          letterSpacing: "-0.02em",
          color: "#111",
          marginBottom: "8px",
        }}
      >
        {title || "No Records Found"}
      </div>
      <div
        style={{
          fontSize: "13px",
          color: "#9ca3af",
          maxWidth: "220px",
          lineHeight: "1.65",
          margin: 0,
        }}
      >
        {subtitle || "No records match your current search or filters."}
      </div>
      {ctaLabel && onCta && (
        <button
          onClick={onCta}
          style={{
            marginTop: "20px",
            background: "#3dcc82",
            color: "#0a2418",
            fontSize: "13px",
            fontWeight: "600",
            padding: "8px 20px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontFamily: "inherit",
            transition: "background 0.15s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#35b873")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#3dcc82")}
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
